// You can write more code here

import { GameInstance } from '@/game/GameComponents/PhaserGame/GameInstance';
import { getGameName } from '@/game/gameHelpers';

/* START OF COMPILED CODE */

/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class MinigameMasteryUI extends Phaser.GameObjects.Container {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 0);

    // backing
    const backing = scene.add.image(-20, 0, '1x1sprite');
    backing.scaleX = 256;
    backing.scaleY = 64;
    backing.setOrigin(0, 0.5);
    backing.visible = false;
    backing.alpha = 0.15;
    backing.alphaTopLeft = 0.15;
    backing.alphaTopRight = 0.15;
    backing.alphaBottomLeft = 0.15;
    backing.alphaBottomRight = 0.15;
    backing.tintTopLeft = 985612;
    backing.tintTopRight = 985612;
    backing.tintBottomLeft = 985612;
    backing.tintBottomRight = 985612;
    this.add(backing);

    // iconBacking
    const iconBacking = scene.add.image(0, 0, 'ui-mastery-pip-backing');
    iconBacking.scaleX = 2;
    iconBacking.scaleY = 2;
    iconBacking.tintTopLeft = 13218713;
    iconBacking.tintTopRight = 13218713;
    iconBacking.tintBottomLeft = 13218713;
    iconBacking.tintBottomRight = 13218713;
    this.add(iconBacking);

    // minigameIcon
    const minigameIcon = scene.add.image(0, 0, 'ui-pip-mysticMatch');
    minigameIcon.scaleX = 2;
    minigameIcon.scaleY = 2;
    this.add(minigameIcon);

    // checkmark
    const checkmark = scene.add.image(28, -28, 'ui-pip-completion-ticked');
    checkmark.scaleX = 2;
    checkmark.scaleY = 2;
    this.add(checkmark);

    // minigameName
    const minigameName = scene.add.bitmapText(
      44,
      -20,
      'Aronui',
      'Mystic Match',
    );
    minigameName.setOrigin(0, 0.5);
    minigameName.tintTopLeft = 5387071;
    minigameName.tintTopRight = 5387071;
    minigameName.tintBottomLeft = 5387071;
    minigameName.tintBottomRight = 5387071;
    minigameName.text = 'Mystic Match';
    minigameName.fontSize = -22;
    this.add(minigameName);

    // minigameAccuracy
    const minigameAccuracy = scene.add.bitmapText(64, 0, 'Aronui', '100%');
    minigameAccuracy.setOrigin(0, 0.5);
    minigameAccuracy.tintTopLeft = 4864576;
    minigameAccuracy.tintTopRight = 4864576;
    minigameAccuracy.tintBottomLeft = 4864576;
    minigameAccuracy.tintBottomRight = 4864576;
    minigameAccuracy.text = '100%';
    minigameAccuracy.fontSize = -16;
    this.add(minigameAccuracy);

    // progressBar
    const progressBar = scene.add.container(44, 22);
    this.add(progressBar);

    // progressBarBacking
    const progressBarBacking = scene.add.nineslice(
      0,
      0,
      'mastery-progress-bar',
      undefined,
      48,
      5,
      2,
      2,
      2,
      2,
    );
    progressBarBacking.scaleX = 4;
    progressBarBacking.scaleY = 4;
    progressBarBacking.setOrigin(0, 0.5);
    progressBar.add(progressBarBacking);

    // progressBarFill
    const progressBarFill = scene.add.nineslice(
      4,
      0,
      'mastery-progress-fill',
      undefined,
      46,
      3,
      1,
      1,
      1,
      1,
    );
    progressBarFill.scaleX = 4;
    progressBarFill.scaleY = 4;
    progressBarFill.setOrigin(0, 0.5);
    progressBar.add(progressBarFill);

    // image_1
    const image_1 = scene.add.image(44, 0, 'mastery_complete3');
    image_1.setOrigin(0, 0.5);
    this.add(image_1);

    this.minigameIcon = minigameIcon;
    this.checkmark = checkmark;
    this.minigameName = minigameName;
    this.minigameAccuracy = minigameAccuracy;
    this.progressBarBacking = progressBarBacking;
    this.progressBarFill = progressBarFill;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private minigameIcon: Phaser.GameObjects.Image;
  private checkmark: Phaser.GameObjects.Image;
  private minigameName: Phaser.GameObjects.BitmapText;
  private minigameAccuracy: Phaser.GameObjects.BitmapText;
  private progressBarBacking: Phaser.GameObjects.NineSlice;
  private progressBarFill: Phaser.GameObjects.NineSlice;

  /* START-USER-CODE */

  /*
    Configures the minigame mastery UI element for a specific minigame.
  */
  setMinigame(game: string) {
    this.minigameName.text = getGameName(game) || '';

    this.minigameIcon.setTexture('ui-pip-' + game);

    const { gamesProgress } = GameInstance.instance.getActiveLevelProgress();
    const minigameStatus = gamesProgress[game];

    if (!minigameStatus) {
      console.warn("couldn't find progress for minigame: " + game);
      return;
    }

    const hasPlayed = minigameStatus.timesPlayed > 0;
    this.minigameIcon.setTexture(hasPlayed ? game : `${game}-inactive`);
    const isMastered = minigameStatus.currentHighestMastery > 90;
    const checkmarkTex = isMastered
      ? 'ui-pip-completion-ticked'
      : 'ui-pip-completion-unticked';
    this.checkmark.setTexture(checkmarkTex);
    this.minigameAccuracy.text = `${Math.floor(
      minigameStatus.currentHighestMastery,
    )}%`;
    const iconAlpha = isMastered ? 1 : 0.4;
    this.minigameIcon.setAlpha(iconAlpha);
    this.checkmark.setVisible(isMastered);

    const padding = 2;
    this.progressBarFill.width =
      ((minigameStatus.currentHighestMastery / 100) *
        (this.progressBarBacking.width * this.progressBarBacking.scaleX)) /
        this.progressBarFill.scaleX -
      padding;
    this.progressBarFill.setVisible(minigameStatus.currentHighestMastery > 0);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
